import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      app: {
        title: 'SophistiScan',
        subtitle: 'Config Tool',
        version: 'v1.0',
      },
      nav: {
        dashboard: 'Dashboard',
        barcodeGenerator: 'Barcode Generator',
        serialConsole: 'Serial Console',
        profiles: 'Profiles',
        history: 'History',
        settings: 'Settings',
        logout: 'Logout',
      },
      auth: {
        login: 'Login',
        register: 'Register',
        email: 'Email',
        password: 'Password',
        displayName: 'Display Name',
        loginTitle: 'Sign In',
        registerTitle: 'Create Account',
        noAccount: "Don't have an account?",
        hasAccount: 'Already have an account?',
        loginError: 'Invalid email or password',
        registerError: 'Registration failed',
      },
      dashboard: {
        welcome: 'Welcome back',
        quickActions: 'Quick Actions',
        recentProfiles: 'Recent Profiles',
        scannerStatus: 'Scanner Status',
        connected: 'Connected',
        disconnected: 'Disconnected',
        generateBarcode: 'Generate Config Barcode',
        openSerial: 'Open Serial Console',
        factoryReset: 'Factory Reset',
        viewProfiles: 'View All Profiles',
      },
      barcode: {
        title: 'Barcode Configuration Generator',
        category: 'Category',
        setting: 'Setting',
        value: 'Value',
        generate: 'Generate Barcode',
        scanThis: 'Scan this barcode with your SQ400H to apply the setting',
        printAll: 'Print All',
        addToQueue: 'Add to Queue',
        queue: 'Configuration Queue',
        clearQueue: 'Clear Queue',
        categories: {
          communication: 'Communication',
          scanning: 'Scanning Mode',
          illumination: 'Illumination & Aiming',
          feedback: 'Sound & Feedback',
          data_format: 'Data Format',
          symbologies: 'Symbologies',
          system: 'System',
        },
      },
      serial: {
        title: 'Serial Console',
        connect: 'Connect Scanner',
        disconnect: 'Disconnect',
        send: 'Send Command',
        operand: 'Operand',
        data: 'Data (hex)',
        permanent: 'Save to flash',
        rawHex: 'Raw HEX',
        response: 'Response',
        log: 'Command Log',
        clear: 'Clear',
        notSupported: 'Web Serial API is not supported in this browser. Please use Chrome or Edge.',
        connectionFailed: 'Failed to connect to scanner',
      },
      profiles: {
        title: 'Scanner Profiles',
        create: 'New Profile',
        edit: 'Edit',
        delete: 'Delete',
        apply: 'Apply Profile',
        duplicate: 'Duplicate',
        default: 'Default',
        custom: 'Custom',
        name: 'Profile Name',
        description: 'Description',
        noProfiles: 'No profiles yet',
        deleteConfirm: 'Are you sure you want to delete this profile?',
        saved: 'Profile saved successfully',
      },
      common: {
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        close: 'Close',
        loading: 'Loading...',
        error: 'Error',
        success: 'Success',
        confirm: 'Confirm',
        back: 'Back',
        next: 'Next',
        default: 'Default',
        custom: 'Custom',
        enabled: 'Enabled',
        disabled: 'Disabled',
        on: 'ON',
        off: 'OFF',
        language: 'Language',
      },
    },
  },
  he: {
    translation: {
      app: {
        title: 'SophistiScan',
        subtitle: 'כלי הגדרות',
        version: 'v1.0',
      },
      nav: {
        dashboard: 'לוח בקרה',
        barcodeGenerator: 'יצירת ברקוד',
        serialConsole: 'קונסול סיריאלי',
        profiles: 'פרופילים',
        history: 'היסטוריה',
        settings: 'הגדרות',
        logout: 'יציאה',
      },
      auth: {
        login: 'התחברות',
        register: 'הרשמה',
        email: 'אימייל',
        password: 'סיסמה',
        displayName: 'שם תצוגה',
        loginTitle: 'כניסה למערכת',
        registerTitle: 'יצירת חשבון',
        noAccount: 'אין לך חשבון?',
        hasAccount: 'כבר יש לך חשבון?',
        loginError: 'אימייל או סיסמה שגויים',
        registerError: 'ההרשמה נכשלה',
      },
      dashboard: {
        welcome: 'ברוך הבא',
        quickActions: 'פעולות מהירות',
        recentProfiles: 'פרופילים אחרונים',
        scannerStatus: 'סטטוס סורק',
        connected: 'מחובר',
        disconnected: 'מנותק',
        generateBarcode: 'יצירת ברקוד הגדרה',
        openSerial: 'קונסול סיריאלי',
        factoryReset: 'איפוס להגדרות יצרן',
        viewProfiles: 'הצג את כל הפרופילים',
      },
      barcode: {
        title: 'יצירת ברקוד הגדרות',
        category: 'קטגוריה',
        setting: 'הגדרה',
        value: 'ערך',
        generate: 'צור ברקוד',
        scanThis: 'סרוק את הברקוד הזה עם ה-SQ400H כדי להחיל את ההגדרה',
        printAll: 'הדפס הכל',
        addToQueue: 'הוסף לתור',
        queue: 'תור הגדרות',
        clearQueue: 'נקה תור',
        categories: {
          communication: 'תקשורת',
          scanning: 'מצב סריקה',
          illumination: 'תאורה וכיוון',
          feedback: 'צליל ומשוב',
          data_format: 'פורמט נתונים',
          symbologies: 'סוגי ברקוד',
          system: 'מערכת',
        },
      },
      serial: {
        title: 'קונסול סיריאלי',
        connect: 'חבר סורק',
        disconnect: 'נתק',
        send: 'שלח פקודה',
        operand: 'אופרנד',
        data: 'נתונים (hex)',
        permanent: 'שמור לפלאש',
        rawHex: 'HEX גולמי',
        response: 'תגובה',
        log: 'יומן פקודות',
        clear: 'נקה',
        notSupported: 'Web Serial API לא נתמך בדפדפן זה. יש להשתמש בכרום או אדג\'.',
        connectionFailed: 'החיבור לסורק נכשל',
      },
      profiles: {
        title: 'פרופילי סורק',
        create: 'פרופיל חדש',
        edit: 'עריכה',
        delete: 'מחיקה',
        apply: 'החל פרופיל',
        duplicate: 'שכפל',
        default: 'ברירת מחדל',
        custom: 'מותאם אישית',
        name: 'שם פרופיל',
        description: 'תיאור',
        noProfiles: 'אין פרופילים עדיין',
        deleteConfirm: 'האם אתה בטוח שברצונך למחוק את הפרופיל?',
        saved: 'הפרופיל נשמר בהצלחה',
      },
      common: {
        save: 'שמור',
        cancel: 'ביטול',
        delete: 'מחק',
        edit: 'ערוך',
        close: 'סגור',
        loading: 'טוען...',
        error: 'שגיאה',
        success: 'הצלחה',
        confirm: 'אישור',
        back: 'חזרה',
        next: 'הבא',
        default: 'ברירת מחדל',
        custom: 'מותאם אישית',
        enabled: 'מופעל',
        disabled: 'מושבת',
        on: 'פעיל',
        off: 'כבוי',
        language: 'שפה',
      },
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('sophistiscan-lang') || 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
